import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MessagecenterService } from 'src/app/services/messagecenter.service';
import { HttpErrorResponse } from '@angular/common/http';
import {
    GetMessageQuery,
    full_message,
    full_message_sent,
    common_message
} from '../../../../models/message';
import {
    PromiseResult,
    ErrorModel,
    ServerError
} from '../../../../models/PromiseResult';
import { TraceClassDecorator } from '@sentry/angular';
import { roles } from '../../../../constant/constant';
import { ProviderStateService } from 'src/app/services/provider-state.service';



@TraceClassDecorator()
@Component({
    selector: 'app-mail-view',
    templateUrl: './mail-view.component.html',
    styleUrls: ['../../../../../assets/css/custom-egd.css']
})
export class MailViewComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private messageService: MessagecenterService,
        private readonly providerstateService: ProviderStateService
    ) {
        this.posting = false;
        this.user = roles.doctor;
    }

    query: GetMessageQuery;
    response: PromiseResult;
    error: ErrorModel;
    slug: string = "";
    serverError: ServerError;
    posting: boolean;
    private readonly user: roles;
    rec_message: full_message;
    sent_message: full_message_sent;
    message: common_message;
    ngOnInit(): void {
        this.slug = this.providerstateService.getProviderSlug();
        this.query = {
            user_guid: '',
            message_id: null,
            sent: null
        };
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };
        this.message = {
            to: '',
            from: '',
            date: null,
            subject: '',
            message: '',
            flagged: null
        };
        this.route.params.subscribe(async (params) => {
            this.query.message_id = Number(params.message_id);
            this.query.user_guid = params.user_guid;
            this.query.sent = params.sent.toString() === 'true';

            if (
                this.query.user_guid != null &&
                this.query.message_id != null &&
                this.query.sent != null
            ) {
                await this.GetMessage();
            } else {
                this.response.success = false;
                this.response.error = {
                    code: 'TOK',
                    message: 'Invalid tokens'
                };
            }
        });
    }

    private async ResetResultModels(): Promise<void> {
        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        };
    }

    private async GetMessage(): Promise<void> {
        await this.ResetResultModels();
        this.posting = true;
        await this.messageService
            .GetFullMessage(this.query, this.user)
            .toPromise()
            .then(async (result: PromiseResult) => {
                this.response = result;
                if (this.response.success) {
                    if (this.query.sent) {
                        this.sent_message = result.data;
                        let to: string = '';
                        if (this.sent_message.egd_users != null) {
                            to =
                                this.sent_message.egd_users.first_name +
                                ' ' +
                                (this.sent_message.egd_users.middle_name == null ? '' : this.sent_message.egd_users.middle_name) +
                                ' ' +
                                this.sent_message.egd_users.last_name;
                        } else {
                            to =
                                this.sent_message.p_accounts.first_name +
                                ' ' +
                                (this.sent_message.p_accounts.middle_name == null ? '' : this.sent_message.p_accounts.middle_name) +
                                ' ' +
                                this.sent_message.p_accounts.last_name;
                        }
                        this.message = {
                            to: to,
                            date: this.sent_message.messages.created_at,
                            subject: this.sent_message.messages.subject,
                            message: this.sent_message.messages.message,
                            flagged: this.sent_message.messages.flagged
                        };
                    } else {
                        this.rec_message = result.data;
                        let from: string = '';
                        if (this.rec_message.messages.egd_users != null) {
                            from =
                                this.rec_message.messages.egd_users.first_name +
                                ' ' +
                                (this.rec_message.messages.egd_users
                                    .middle_name == null ? '' : this.rec_message.messages.egd_users
                                    .middle_name) +
                                ' ' +
                                this.rec_message.messages.egd_users.last_name;
                        } else {
                            from =
                                this.rec_message.messages.p_accounts
                                    .first_name +
                                ' ' +
                                (this.rec_message.messages.p_accounts
                                    .middle_name == null ? '' : this.rec_message.messages.p_accounts
                                    .middle_name) +
                                ' ' +
                                this.rec_message.messages.p_accounts.last_name;
                        }
                        this.message = {
                            from: from,
                            date: this.rec_message.messages.created_at,
                            subject: this.rec_message.messages.subject,
                            message: this.rec_message.messages.message,
                            flagged: this.rec_message.flagged
                        };
                    }
                    //await this.InitiateModels();
                }
                this.posting = false;
            })
            .catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.posting = false;
            });
    }
}
